import { IconDefinition } from "./types";

const menu: IconDefinition = {
  iconName: "menu",
  width: 16,
  height: 16,
  svgPathData: "M15.5 13H.5M15.5 8H.5M15.5 3H.5",
  iconType: "stroke",
};

export { menu };
